import { IProgramId } from '@ucheba/store/institutions/programs/programId/types'
import { useCallback, useMemo } from 'react'

export const useStudyAdvantages = (
  list: IProgramId['features']
): IProgramId['features'] => {
  const getText = useCallback((text: string) => {
    const jsonText = JSON.stringify(text)

    /** вместо \n подставляем </br> */
    const htmlText = jsonText.replace(/\\n/gm, '</br>')

    return JSON.parse(htmlText)
  }, [])

  return useMemo(() => {
    if (list) {
      return list.map((item) => {
        return {
          ...item,
          description: getText(item.description),
        }
      })
    }

    return []
  }, [list, getText])
}
